// Logica punteggio World Taekwondo 2026

/**
 * Calcola i punti per un'azione.
 * @param {string} technique  - ID tecnica (es. 'Bn', 'Pugno', 'Gr', ...)
 * @param {string} target     - 'corpo' | 'testa'
 * @param {string} outcome    - 'punto' | 'tocco' | 'miss'
 * @param {boolean} technicalBonus - true se con rotazione
 * @returns {number} punti
 */
export function calculatePoints(technique, target, outcome, technicalBonus = false) {
  if (outcome !== 'punto') return 0;

  // Pugno e Gerogi: sempre 1 punto solo su corpo
  if (technique === 'Pugno' || technique === 'Gr') {
    return target === 'corpo' ? 1 : 0;
  }

  // Clash: 0 punti (parata)
  if (technique === 'Clsh') return 0;

  // Calci
  if (target === 'corpo') {
    return technicalBonus ? 4 : 2;
  }
  if (target === 'testa') {
    return technicalBonus ? 6 : 3;
  }

  return 0;
}

/**
 * Formatta il display dei punti con colore e label
 */
export function getPointsDisplay(points) {
  if (points === 0) return { label: '0', color: '#888' };
  if (points === 1) return { label: '1', color: '#4CAF50' };
  if (points === 2) return { label: '2', color: '#4CAF50' };
  if (points === 3) return { label: '3', color: '#FF9800' };
  if (points === 4) return { label: '4', color: '#FF9800' };
  if (points === 6) return { label: '6', color: '#f44336' };
  return { label: String(points), color: '#4CAF50' };
}

/**
 * Calcola score totale da array di azioni e penalità
 */
export function calculateTotalScores(actions, penalties) {
  const scores = { blue: 0, red: 0 };

  // Punti da azioni
  actions.forEach(action => {
    if (action.outcome === 'punto') {
      if (action.athlete === 'blue') scores.blue += action.points || 0;
      if (action.athlete === 'red')  scores.red  += action.points || 0;
    }
  });

  // Gam-jeom: ogni penalità dell'atleta dà 1pt all'avversario
  (penalties.blue || []).forEach(() => { scores.red += 1; });
  (penalties.red  || []).forEach(() => { scores.blue += 1; });

  return scores;
}
